import { Configuration, ProfileApiApi, UserProfile } from "../clients/ogg";
import { IToastProvider, IAuthenticationProvider, IProfileService } from "../types";

class ProfileService implements IProfileService{
    toastProvider: IToastProvider;
    profileApi: ProfileApiApi;
    authProvider: IAuthenticationProvider;

    public constructor(
        apiConfig: Configuration,
        toastProvider: IToastProvider,
        authProvider: IAuthenticationProvider
    ) {
        this.toastProvider = toastProvider;
        this.profileApi = new ProfileApiApi(apiConfig);
        this.authProvider = authProvider;
    }

    async getProfile(): Promise<UserProfile> {
        return await this.profileApi.getProfile({
            xAccessTokenType: this.authProvider.accessTokenType,
            xOggUserEmail: await this.authProvider.getUserEmail(),
        });
    }
}

export { ProfileService }